var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWznn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#262626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7963 6H8V7.75372H13.6058L8.02982 11.172V20H9.58035V15.6008L15.2458 19.9703H16.8261V19.0786V18.93V11.4395H10.952L16.8261 7.69427V6H16.7963ZM15.1861 13.1338L15.2159 17.6519L9.55054 13.1338H15.1861Z",
    fill: "url(#paint0_linear_829_2220)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_829_2220",
    x1: 7.3009,
    y1: 2.94363,
    x2: 17.1485,
    y2: 3.0502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7946E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF005C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWznn);
export default __webpack_public_path__ + "static/media/wznn.c0a7f8954e6fbf76afc79643ea3838db.svg";
export { ForwardRef as ReactComponent };